import React from 'react';
import {
  Image,
  ImageBackground,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

import BackgroundDesktop from 'web/assets/images/background-404-desktop.jpg';
import BackgroundMobile from 'web/assets/images/background-404-mobile.jpg';
import Logo from 'web/assets/images/logo-white.png';
import routes from 'web/navigation/routes';

const NotFoundScreen = () => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const navigate = useNavigate();

  return (
    <ImageBackground
      source={{ uri: isBigScreen ? BackgroundDesktop : BackgroundMobile }}
      style={style.root}
    >
      <View accessibilityRole="navigation" style={style.header}>
        <TouchableOpacity
          accessibilityRole="link"
          href="https://paidy.com"
          hrefAttrs={{ target: '_blank' }}
        >
          <Image source={{ uri: Logo }} style={style.headerImage} />
        </TouchableOpacity>
      </View>
      <View accessibilityRole="main" style={style.main}>
        <View style={style.card}>
          <Text style={style.textTitle}>
            お探しのページが{'\n'}
            見つかりませんでした
          </Text>
          <Text>
            お探しのページは削除されたか、URLが変更され{'\n'}
            ているため、表示することができません。
            {'\n\n'}
            お手数ですが、
            <Text
              accessibilityRole="link"
              onPress={() => navigate(routes.unauthenticated.root)}
              style={style.textLink}
            >
              ペイディのトップページ
            </Text>
            よりもう
            {'\n'}
            一度お試しください。
          </Text>
        </View>
      </View>
    </ImageBackground>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
  },
  header: {
    padding: 24,
    alignItems: 'center',
  },
  headerImage: {
    width: 104,
    height: 40,
    resizeMode: 'cover',
  },
  main: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    padding: 32,
    borderRadius: 24,
    width: '100%',
    maxWidth: 640,
    textAlign: 'center',
  },
  textTitle: {
    fontWeight: 'bold',
    marginBottom: 32,
  },
  textLink: {
    color: '#E52581',
    textDecorationLine: 'underline',
  },
});

export default NotFoundScreen;
